;(function ( $ ) {

  var $url = $.url(),
      current_path = $url.attr('path');

  $.fn.ruckusCarousel = function() {
    if (!this.length) { return; }

    // Enable multiple selectors.
    return this.each(function() {
      // Initialize the carousels
      var slick = $(this).slick(carouselConfig($(this)));
      if ($(this).hasClass('carousel-front')) {
        $('.billboard-nav-btn').wrapAll('<div class="billboard-nav">');
      }
    });
  };

  $.fn.resizeCarouselText = function() {
    var maxheight = 0,
        $boxes    = $('.slide-text');

    $boxes.each(function()
    {
      var $box         = $(this),
          $titleandblurb = $box.find('> *'),
          totalHeight    = calcCombinedHeight($titleandblurb);
      //console.log('total ' + totalHeight);
      //console.log('box ' + $box.height());
      maxheight = (maxheight < totalHeight) ? totalHeight : maxheight;
    });

    $boxes.height(maxheight);
  };

  function calcCombinedHeight($element)
  {
    var height = 0;

    $element.each(function()
    {
      height += $(this).outerHeight();
    });

    return height;
  }

  function carouselConfig(carousel)
  {
    switch(true)
    {
      case (carousel.hasClass('carousel-front')):
        return {
          arrows: true,
          prevArrow: '<div class="billboard-nav-btn prev"><svg class="icon"><use xlink:href="/ruckus.svg#chevron-thin-left"></use></svg></div>',
          nextArrow: '<div class="billboard-nav-btn next"><svg class="icon"><use xlink:href="/ruckus.svg#chevron-thin-right"></use></svg></div>',
          dots: false,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 8000,
          fade: true,
          cssEase: 'linear',
          responsive: [
            //{
              //breakpoint: 640,
              //settings: {
                //dots: false,
              //}
            //}
          ]
        };
      // case (carousel.hasClass('carousel-inpage')):
      //   return {
      //     arrows: true,
      //     dots: true,
      //     infinite: true,
      //     slidesToShow: 3,
      //     slidesToScroll: 3,
      //     responsive: [
      //       {
      //         breakpoint: 640,
      //         settings: {
      //           slidesToShow: 2,
      //           slidesToScroll: 2
      //         }
      //       },
      //       {
      //         breakpoint: 480,
      //         settings: {
      //           slidesToShow: 1,
      //           slidesToScroll: 1
      //         }
      //       }
      //     ]
      //   };
    }
  }
})( jQuery );

